import useFaqPage from "./hooks/useFaqPage";
import FaqView from "./view";
import { PropsView } from "./Models/faq";

export default function Faq() {
  const props: PropsView = useFaqPage();

  return (
    <FaqView
      goBack={props.goBack}
      goToContact={props.goToContact}
      infos={props.infos}
    />
  );
}
